export default __webpack_public_path__ + "static/media/webby-logo.006cc1f6.svg";